/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import Card from '../../../../../../shared/components/Card';
import { ContentCard } from '../../../../../../shared/components/Card/components/CardComponents';
import checkValue from '../../../../../../utils/values';
import ExportPdf from '../DownloadPdf/ExportPdf';
import TableComponents from './components/TableComponents';
import { ICardWithTable } from './interface';

function CardWithTable(props: ICardWithTable) {
  let totalIncome = 0;
  let totalReceived = 0;
  let totalPassedOn = 0;

  return (
    <Card
      isActive={props.isActive}
      title={props.title}
      gridArea={props.gridArea}
      subtitle={props.subtitle}
      rightButton={ExportPdf({ title: '', body: '' })}
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      width="100%"
      height="100%"
      backgroundColor="#FFFFFF">
      <ContentCard>
        <TableComponents.Table>
          <TableComponents.Thead>
            <TableComponents.Tr>
              <TableComponents.Td>Parceiro</TableComponents.Td>
              <TableComponents.Td>Tarifas Recebidas</TableComponents.Td>
              <TableComponents.Td>Tarifas Repassadas</TableComponents.Td>
              <TableComponents.Td>Resultado</TableComponents.Td>
            </TableComponents.Tr>
          </TableComponents.Thead>
          <TableComponents.Tbody textColor={props.valueColor}>
            {props.data.map((partner) => {
              totalIncome += partner.income;
              totalPassedOn += partner.valuePassedOn;
              totalReceived += partner.valueReceived;

              return (
                <TableComponents.Tr key={partner.partner}>
                  <TableComponents.Td key={`${partner.partner} partner`}>
                    {partner.partner}
                  </TableComponents.Td>
                  <TableComponents.Td key={`${partner.partner} received`}>
                    {checkValue(partner.valueReceived).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </TableComponents.Td>
                  <TableComponents.Td key={`${partner.partner} passedOn`}>
                    {checkValue(partner.valuePassedOn).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </TableComponents.Td>
                  <TableComponents.Td key={`${partner.partner} income`}>
                    {checkValue(partner.income).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </TableComponents.Td>
                </TableComponents.Tr>
              );
            })}
          </TableComponents.Tbody>
          <TableComponents.Tfooter>
            <TableComponents.Tr>
              <TableComponents.Td>Total</TableComponents.Td>
              <TableComponents.Td>
                {totalReceived.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </TableComponents.Td>
              <TableComponents.Td>
                {totalPassedOn.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </TableComponents.Td>
              <TableComponents.Td>
                {totalIncome.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </TableComponents.Td>
            </TableComponents.Tr>
          </TableComponents.Tfooter>
        </TableComponents.Table>
      </ContentCard>
    </Card>
  );
}

export default CardWithTable;
